export type AppEnvironmentName = 'local' | 'dev' | 'prod';

export interface AppEnvironment {
    name: AppEnvironmentName;
    production: boolean;
    /** API base URL including `/api` prefix (or relative `/api` for local proxy). */
    apiUrl: string;
    /** When true, domain services use in-memory mocks instead of HTTP */
    useMockApi: boolean;
    /**
     * When true, the sidebar "Viewing as" role switcher renders (demo-only — it real-logs-in
     * as canned demo accounts). MUST be false for any real production tenant.
     */
    demoRoleSwitcher: boolean;
}

/** Whether an outgoing HTTP request targets the Cyan Blue API (local proxy or absolute dev/prod URL). */
export function isCyanApiRequest(url: string, apiUrl: string): boolean {
    const normalized = apiUrl.replace(/\/$/, '');
    return url.startsWith('/api') || (normalized.length > 0 && url.startsWith(normalized));
}
